module.exports = __webpack_public_path__ + "static/media/Magnifier.cbc7b71d.svg";